import BX from 'BX';
import { bindEvents } from './QuickCityChooser.js';

BX.namespace('SaleLocationSelectorSearch');

BX.SaleLocationSelectorSearch.init = function() {
	document.querySelectorAll('[is="quick-city-chooser"]')
		.forEach(bindEvents);
}
